import React from 'react';
import styles from './styles/EditSidebar.module.css';
import { useEditorUI } from '../../../context/EditorUIContext';
import EditSituation from './EditSituation';
import EditChoice from './EditChoice';
import EditGroup from './EditGroup';

/**
 * Shows the editor for whatever is selected. Selection is a `{ type, id }` pair,
 * so this only has to know which panel to mount — each one looks its own subject
 * up from the graph and therefore always renders the current data.
 *
 * Each panel is keyed by the selected id, so switching to another item mounts a
 * fresh panel — and fresh text editors — rather than reusing one that still
 * holds the previous item's typing, undo history and in-flight blur.
 */
const EditSidebar = ({ setRenderEditSidebar }) => {
    const { selection } = useEditorUI();

    return (
        <div className={styles.container}>
            {selection.type === 'situation' && (
                <EditSituation
                    key={selection.id}
                    nodeId={selection.id}
                    setRenderEditSidebar={setRenderEditSidebar}
                />
            )}
            {selection.type === 'choice' && (
                <EditChoice
                    key={selection.id}
                    edgeId={selection.id}
                    setRenderEditSidebar={setRenderEditSidebar}
                />
            )}
            {selection.type === 'group' && (
                <EditGroup
                    key={selection.id}
                    groupId={selection.id}
                    setRenderEditSidebar={setRenderEditSidebar}
                />
            )}

            {!selection.type && <div className={styles.noSelection}>No Element Selected</div>}
        </div>
    );
};

export default EditSidebar;
